"use strict";

var _slicedToArray = require("/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _toConsumableArray = require("/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/createClass");

var _get = require("/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFilteredProgramAccounts = exports.getNameOwner = exports.getNameAccountKey = exports.getHashedName = exports.signAndSendTransactionInstructions = exports.Numberu64 = exports.Numberu32 = void 0;

var assert_1 = __importDefault(require("assert"));

var crypto_1 = require("crypto");

var web3_js_1 = require("@solana/web3.js");

var bn_js_1 = __importDefault(require("bn.js"));

var bindings_1 = require("./bindings");

var state_1 = require("./state");

var Numberu32 = /*#__PURE__*/function (_bn_js_1$default) {
  _inherits(Numberu32, _bn_js_1$default);

  var _super = _createSuper(Numberu32);

  function Numberu32() {
    _classCallCheck(this, Numberu32);

    return _super.apply(this, arguments);
  }

  _createClass(Numberu32, [{
    key: "toBuffer",
    value:
    /**
     * Convert to Buffer representation
     */
    function toBuffer() {
      var a = _get(_getPrototypeOf(Numberu32.prototype), "toArray", this).call(this).reverse();

      var b = Buffer.from(a);

      if (b.length === 4) {
        return b;
      }

      assert_1.default(b.length < 4, 'Numberu32 too large');
      var zeroPad = Buffer.alloc(4);
      b.copy(zeroPad);
      return zeroPad;
    }
    /**
     * Construct a Numberu64 from Buffer representation
     */

  }], [{
    key: "fromBuffer",
    value: function fromBuffer(buffer) {
      assert_1.default(buffer.length === 4, "Invalid buffer length: ".concat(buffer.length));
      return new bn_js_1.default(_toConsumableArray(buffer).reverse().map(function (i) {
        return "00".concat(i.toString(16)).slice(-2);
      }).join(''), 16);
    }
  }]);

  return Numberu32;
}(bn_js_1.default);

exports.Numberu32 = Numberu32;

var Numberu64 = /*#__PURE__*/function (_bn_js_1$default2) {
  _inherits(Numberu64, _bn_js_1$default2);

  var _super2 = _createSuper(Numberu64);

  function Numberu64() {
    _classCallCheck(this, Numberu64);

    return _super2.apply(this, arguments);
  }

  _createClass(Numberu64, [{
    key: "toBuffer",
    value:
    /**
     * Convert to Buffer representation
     */
    function toBuffer() {
      var a = _get(_getPrototypeOf(Numberu64.prototype), "toArray", this).call(this).reverse();

      var b = Buffer.from(a);

      if (b.length === 8) {
        return b;
      }

      assert_1.default(b.length < 8, 'Numberu64 too large');
      var zeroPad = Buffer.alloc(8);
      b.copy(zeroPad);
      return zeroPad;
    }
    /**
     * Construct a Numberu64 from Buffer representation
     */

  }], [{
    key: "fromBuffer",
    value: function fromBuffer(buffer) {
      assert_1.default(buffer.length === 8, "Invalid buffer length: ".concat(buffer.length));
      return new bn_js_1.default(_toConsumableArray(buffer).reverse().map(function (i) {
        return "00".concat(i.toString(16)).slice(-2);
      }).join(''), 16);
    }
  }]);

  return Numberu64;
}(bn_js_1.default);

exports.Numberu64 = Numberu64;

var signAndSendTransactionInstructions = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee( // sign and send transaction
  connection, signers, feePayer, txInstructions) {
    var tx;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            tx = new web3_js_1.Transaction();
            tx.feePayer = feePayer.publicKey;
            signers.push(feePayer);
            tx.add.apply(tx, _toConsumableArray(txInstructions));
            _context.next = 6;
            return connection.sendTransaction(tx, signers);

          case 6:
            return _context.abrupt("return", _context.sent);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function signAndSendTransactionInstructions(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

exports.signAndSendTransactionInstructions = signAndSendTransactionInstructions;

function getHashedName(_x5) {
  return _getHashedName.apply(this, arguments);
}

function _getHashedName() {
  _getHashedName = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(name) {
    var input, buffer;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            input = bindings_1.HASH_PREFIX + name;
            buffer = crypto_1.createHash('sha256').update(input, 'utf8').digest();
            return _context2.abrupt("return", buffer);

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getHashedName.apply(this, arguments);
}

exports.getHashedName = getHashedName;

function getNameAccountKey(_x6, _x7, _x8) {
  return _getNameAccountKey.apply(this, arguments);
}

function _getNameAccountKey() {
  _getNameAccountKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(hashed_name, nameClass, nameParent) {
    var seeds, _yield$web3_js_1$Publ, _yield$web3_js_1$Publ2, nameAccountKey;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            seeds = [hashed_name];

            if (nameClass) {
              seeds.push(nameClass.toBuffer());
            } else {
              seeds.push(Buffer.alloc(32));
            }

            if (nameParent) {
              seeds.push(nameParent.toBuffer());
            } else {
              seeds.push(Buffer.alloc(32));
            }

            _context3.next = 5;
            return web3_js_1.PublicKey.findProgramAddress(seeds, bindings_1.NAME_PROGRAM_ID);

          case 5:
            _yield$web3_js_1$Publ = _context3.sent;
            _yield$web3_js_1$Publ2 = _slicedToArray(_yield$web3_js_1$Publ, 1);
            nameAccountKey = _yield$web3_js_1$Publ2[0];
            return _context3.abrupt("return", nameAccountKey);

          case 9:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getNameAccountKey.apply(this, arguments);
}

exports.getNameAccountKey = getNameAccountKey;

function getNameOwner(_x9, _x10) {
  return _getNameOwner.apply(this, arguments);
}

function _getNameOwner() {
  _getNameOwner = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(connection, nameAccountKey) {
    var nameAccount;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return connection.getAccountInfo(nameAccountKey);

          case 2:
            nameAccount = _context4.sent;

            if (nameAccount) {
              _context4.next = 5;
              break;
            }

            throw new Error('Unable to find the given account.');

          case 5:
            return _context4.abrupt("return", state_1.NameRegistryState.retrieve(connection, nameAccountKey));

          case 6:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _getNameOwner.apply(this, arguments);
}

exports.getNameOwner = getNameOwner; //Taken from Serum

function getFilteredProgramAccounts(_x11, _x12, _x13) {
  return _getFilteredProgramAccounts.apply(this, arguments);
}

function _getFilteredProgramAccounts() {
  _getFilteredProgramAccounts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(connection, programId, filters) {
    var resp;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return connection.getProgramAccounts(programId, {
              commitment: connection.commitment,
              filters: filters,
              encoding: 'base64'
            });

          case 2:
            resp = _context5.sent;
            return _context5.abrupt("return", resp.map(function (_ref2) {
              var pubkey = _ref2.pubkey,
                  _ref2$account = _ref2.account,
                  data = _ref2$account.data,
                  executable = _ref2$account.executable,
                  owner = _ref2$account.owner,
                  lamports = _ref2$account.lamports;
              return {
                publicKey: pubkey,
                accountInfo: {
                  data: data,
                  executable: executable,
                  owner: owner,
                  lamports: lamports
                }
              };
            }));

          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _getFilteredProgramAccounts.apply(this, arguments);
}

exports.getFilteredProgramAccounts = getFilteredProgramAccounts;